import './Label.css';
import PropTypes from 'prop-types';

const Input = (props) => {
  return (
    <label className="boldLabel">{props.text}</label>
  );
};

Input.propTypes = {
  text: PropTypes.string,
};

export default Input;
